(function(){
'use strict';
var ELIGIBLE=[15954943541622,15953965220214];
var saving=false;
function codeFor(q){return q>=76?'LEAVERS27-76':q>=50?'LEAVERS27-50':null;}
function isLeavers(item){return ELIGIBLE.includes(Number(item.product_id));}
async function currentCart(){var response=await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});if(!response.ok)throw new Error('Basket unavailable');return response.json();}
function state(cart){
var items=(cart.items||[]).filter(isLeavers);
var count=items.reduce(function(n,i){return n+Number(i.quantity||0)},0);
var fingerprint=items.map(function(i){return String(i.key)+':'+String(i.quantity)}).sort().join('|');
return {quantity:count,code:codeFor(count),fingerprint:fingerprint};
}
function apply(s,target){sessionStorage.setItem('pe-leavers-2027-applied',JSON.stringify({fingerprint:s.fingerprint,code:s.code}));window.location.assign('/discount/'+encodeURIComponent(s.code)+'?redirect='+encodeURIComponent(target));}
async function syncCart(){
if(!/^\/cart\/?$/.test(location.pathname))return;
try{var cart=await currentCart();var s=state(cart);
 if(!s.code)return;
 var last={};try{last=JSON.parse(sessionStorage.getItem('pe-leavers-2027-applied')||'{}')}catch(ignore){}
 if(last.fingerprint===s.fingerprint&&last.code===s.code)return;
 apply(s,'/cart');
}catch(error){console.warn('Leavers quantity pricing could not be applied automatically:',error);}
}
async function interceptCheckout(evt){
var node=evt.target&&evt.target.closest&&evt.target.closest('button[name="checkout"],input[name="checkout"],.cart__checkout-button,a[href^="/checkout"],a[href^="/checkouts/"]');
if(!node||saving)return;
var cartLocation=location.pathname==='/cart'||!!node.closest('cart-drawer,.cart-drawer,#CartDrawer,.cart__footer');
if(!cartLocation)return;
evt.preventDefault();evt.stopPropagation();
saving=true;
try{var s=state(await currentCart());
 if(s.code){apply(s,'/checkout');return;}
 window.location.assign('/checkout');
}catch(error){console.warn('Could not check Leavers tier; continuing to normal checkout',error);window.location.assign('/checkout');}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',syncCart);else syncCart();
document.addEventListener('click',interceptCheckout,true);
document.addEventListener('submit',function(e){
var submitter=e.submitter;
if(submitter&&submitter.matches&&submitter.matches('[name="checkout"]')){
  interceptCheckout({target:submitter,preventDefault:function(){e.preventDefault();},stopPropagation:function(){e.stopPropagation();}});
}
},true);
})();